// extracted by css-extract-rspack-plugin
export default {"modal":"JdGHQq","root":"r4aORK","text":"n1DUrp","options":"Lo0L6e","footer":"nLRNKD"};